import { memo } from "react";
import PropTypes from "prop-types";
import Paragraphs from "app/pages/.shared/Paragraphs";
import "./Board.scss";
import MoreDetails from "app/pages/.shared/MoreDetails";
import { FormattedMessage } from "react-intl";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { LessIcon, MoreIcon } from "app/icons/navigation";
import { ICON_SIZES } from "app/constants";

const Board = ({ name, paragraphs = [], moreDetails = [] }) => {
	return (
		<div className="board">
			<Typography
				variant={TYPOGRAPHY_VARIANTS.LARGE}
				isBold
				className="board__label"
				data-testid="board-label"
				component="h3"
			>
				{name}
			</Typography>
			<div className="board__intro" data-testid="board-intro">
				<Paragraphs paragraphs={paragraphs} enableHTMLFormatting />
			</div>

			{moreDetails.length > 0 && (
				<div className="board__details" data-testid="board-details">
					<MoreDetails
						expandedIcon={<LessIcon size={ICON_SIZES.XS} />}
						collapsedIcon={<MoreIcon size={ICON_SIZES.XS} />}
						expandedLabel={<FormattedMessage id="product.page.less.details" />}
						collapsedLabel={<FormattedMessage id="product.page.more.details" />}
					>
						<Paragraphs paragraphs={moreDetails} enableHTMLFormatting={true} />
					</MoreDetails>
				</div>
			)}
		</div>
	);
};

Board.propTypes = {
	name: PropTypes.string,
	paragraphs: PropTypes.arrayOf(PropTypes.string),
	moreDetails: PropTypes.arrayOf(PropTypes.string),
};

export default memo(Board);
